import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, signal } from '@angular/core';
import * as ClaimTrackerModels from '@claim-tracker/common/models';
import isNil from 'lodash/isNil';

import { expandCollapseAnimation } from '../shared/animations/expand-collapse.animation';
import { fadeInOutAnimation } from '../shared/animations/fade-in-out.animation';
import { IdleTrackingDirective } from '../shared/idle-tracking/idle-tracking.directive';
import { ClaimActivityComponent } from './claim-activity/claim-activity.component';
import { ClaimRepsComponent } from './claim-reps/claim-reps.component';
import { ClaimDetailsService } from './services/claim-details.service';

/**
 * Component for displaying claim details.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-claim-details',
	imports: [ClaimActivityComponent, ClaimRepsComponent, DatePipe, IdleTrackingDirective],
	templateUrl: './claim-details.component.html',
	styleUrls: ['./claim-details.component.css'],
	providers: [ClaimDetailsService],
	animations: [fadeInOutAnimation(), expandCollapseAnimation({ delayEnterMS: 300 })]
})
export class ClaimDetailsComponent implements OnInit {
	readonly LOADING_SPINNER_DELAY_MS = 500;

	loading: boolean;
	showLoadingSpinner = signal(false);
	showClaimDetails = signal(false);

	claim: ClaimTrackerModels.com.aoins.claims.claim.Claim;

	/**
	 * @param claimDetailsService the claim details service
	 * @param elementRef the reference to the current element
	 */
	constructor(
		private claimDetailsService: ClaimDetailsService,
		private elementRef: ElementRef
	) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.loading = true;

		// only show the spinner if loading is longer than the specified spinner delay
		setTimeout(() => {
			if (this.loading) {
				this.showLoadingSpinner.set(true);
			}
		}, this.LOADING_SPINNER_DELAY_MS);

		this.claimDetailsService.getClaimDetails().subscribe({
			next: claim => (this.claim = claim),
			complete: () => {
				this.loading = false;
				this.showLoadingSpinner.set(false);

				if (!isNil(this.claim)) {
					this.showClaimDetails.set(true);

					// set focus to the header
					setTimeout(() => {
						this.elementRef.nativeElement.querySelector('h1')?.focus();
					});
				}
			}
		});
	}
}
